import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@gridscale/ingrid/elements/button';
import { filter } from 'rxjs';
import { NgIf } from '@angular/common';
import { LocalstorageService } from '@gridscale/gs-services/localstorage.service';

@Component({
    imports: [ButtonModule, NgIf, TranslateModule],
    selector: 'app-jumpin-error',
    templateUrl: './jumpin-error.component.html',
    styleUrls: ['./jumpin-error.component.scss']
})
export class JumpinErrorComponent implements OnInit {
  backAccount: string | undefined;

  constructor(private router: Router, private localStorage: LocalstorageService) { }

  ngOnInit() {
    this.localStorage.getItem$('jumpin_last_account').pipe(
      filter(_account => !!_account)
    ).subscribe(_account => {
      this.backAccount = _account!;
    });
  }

  goBack() {
    this.router.navigate(['/Accounts', this.backAccount]);
  }
}
